import { render, staticRenderFns } from "./edit-result-modal.vue?vue&type=template&id=5279715e"
import script from "./edit-result-modal.vue?vue&type=script&lang=js"
export * from "./edit-result-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports